import { render, staticRenderFns } from "./ContentSSR.vue?vue&type=template&id=297e5046&scoped=true"
import script from "./ContentSSR.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentSSR.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContentSSR.vue?vue&type=style&index=0&id=297e5046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297e5046",
  null
  
)

export default component.exports